export default __webpack_public_path__ + "static/power-41508658c2775e342f43ea24553406cd.svg";